import { noop } from 'lodash/fp';
import { api } from './api';
import { safeDownload } from '@/download';

const exportsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listOrganisationExports: builder.query<OrganisationExport[], number>({
      query: (organisationId) => `organisations/${organisationId}/exports`,
    }),
    downloadOrganisationExportPart: builder.mutation<
      { url: string },
      { organisationId: number; exportId: string; n: number }
    >({
      query: ({ organisationId, exportId, n }) => ({
        url: `organisations/${organisationId}/exports/${exportId}/parts/${n}/download`,
        method: 'POST',
      }),
      // A failed call is the caller's to answer; it is only swallowed here so
      // this chain does not surface it as an unhandled rejection.
      onQueryStarted: async (_, { queryFulfilled }) => {
        queryFulfilled.then(({ data }) => {
          safeDownload(data.url);
        }, noop);
      },
    }),
  }),
});

// One part of an export: a separately downloadable archive.
export type OrganisationExportPart = {
  n: number;
  size: number;
  fileCount: number;
};

// A data export freight holds for an organisation, available to download
// until it expires.
export type OrganisationExport = {
  id: string;
  name: string;
  createdAt: string;
  expiresAt: string;
  products: string[];
  parts: OrganisationExportPart[];
};

export const {
  useListOrganisationExportsQuery,
  useDownloadOrganisationExportPartMutation,
} = exportsApi;

export { exportsApi };
